import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { checkGmakerTemplate } from '@/api/gmaker/template.js';

export default {
  name: 'checkGmakerTemplate.vue',

  props: {
    templateId: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: 'common'
    }
  },

  computed: {
    buttonAttrs: function buttonAttrs() {
      return _extends({
        plain: true,
        type: 'text',
        loading: this.loading
      }, this.attrs);
    },
    text: function text() {
      return this.type === 'proxy' ? '复制为代制作模板' : '复制为通用模板';
    }
  },

  methods: {
    handleClick: function handleClick() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                _context.next = 4;
                return checkGmakerTemplate({
                  id: _this.templateId,
                  is_spend_share: _this.type === 'proxy' ? 1 : 0
                });

              case 4:
                _this.$emit('success');
                _this.loading = false;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);
                _this.loading = false;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    }
  }
};